import {  useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { lang } from "../../language/Strings";
import { GoogleButton } from "./GoogleButton";
import { authManager } from "src/main";
import { routes } from "src/routes";
import { isMobile } from "src/utils/isMobile";
import { portalApiClient } from "src/api/apiClient";
import { apiUrls } from "src/consts/ApiUrls";
import { ShowToast } from "src/components/Toast";
import { Spinner } from "src/components/LoadingSpinner";

export default function LoginComponent() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [loginCode, setLoginCode] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    sessionStorage.setItem("LOGINCODE", "");
    authManager.listeners.add((state) => {
      if (state.isAuthenticated){
        setIsAuthenticated(true);
      }
    })
  }, []);

  useEffect(() => {
    if (isAuthenticated || loginCode) {
      
      setIsLoading(true);

      portalApiClient
        .get(apiUrls.me)
        .then((res) => {
          if (res.status === 200) {
            navigate(routes.Map.url(res.data.companyId!, undefined));
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.error("API call failed:", err, err.message, err.stack);
          ShowToast(lang.errorGettingUser, "error", 3000);
          authManager.signOut();
          setLoginCode("");
          setIsLoading(false);
        });
    }
  }, [isAuthenticated, loginCode, navigate]);

  return (
    <div
      className={`w-screen h-screen ${
        !isMobile() && "grid grid-cols-3"
      } bg-top-image bg-cover bg-no-repeat`}
    >
      <div></div>
      <div className="pt-10 flex flex-col items-center">
        <img
          alt="Green Logo"
          title="Green logo"
          className={`w-[80%] h-auto mb-4 `}
          src="/getsitelogo.png"
        />

        <div className="w-full bg-white rounded-xl p-10 ">
          <h2 className="w-full text-center font-semibold text-2xl mb-4 text-Grey7">
            {lang.logIn}
          </h2>

          <button
            id="microsoft-login-button"
            className="flex items-center bg-white border border-gray-300 rounded-lg shadow-md px-2 py-2 font-semibold text-gray-800 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 w-full mb-2"
            onClick={() => authManager.signIn("microsoft")}
          >
            <img
              alt="Microsoft logo"
              title={lang.logInWithMicrosoft}
              className="w-10 h-10 mr-4"
              src="/microsoft-icon.png"
            />
            <span>{lang.logInWithMicrosoft}</span>
          </button>
          <GoogleButton onClick={() => authManager.signIn("google")} />
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const el = document.getElementById("login-code");
            const loginCode = (el as HTMLInputElement)?.value || "";
            if (loginCode) {
              setLoginCode(loginCode);
              sessionStorage.setItem("LOGINCODE", loginCode);
            }
          }}
        >
          <div className="relative w-[90%] items-center flex  h-10  border border-PrimaryGreen rounded-lg  ">
            <input
              id="login-code"
              type="text"
              placeholder={lang.loginCode}
              className="pl-2 pr-10 w-[88%] border-none focus:border-none active:border-none focus:outline-none focus:ring-0"
            />
            <button type="submit">
              <i className="fa-solid cursor-pointer fa-arrow-right absolute right-[5%] top-1/2 transform -translate-y-1/2 text-PrimaryGreen"></i>
            </button>
          </div>
        </form>
      </div>
      {isLoading && <Spinner />}
    </div>
  );
}
